<template>
  <div>
    <div v-if="loading">
      <px-circular-loading />
    </div>
    <div v-if="!respostas.length && !loading" align="center" class="headline">
      Nenhum produto encontrado!
    </div>
    <v-expansion-panels
      v-if="respostas && respostas.length"
      class="rounded-card"
      multiple
      focusable>
      <v-expansion-panel active-class="rounded-card"
                         v-for="resposta in orderedRespostas"
                         :key="resposta.id">
        <v-expansion-panel-header>
          <v-row dense align="center">
            <v-col cols="12" sm="5" class="text-truncate">
              <px-indicador-compra small
                                   icon-class="mb-1"
                                   :resposta="resposta"/>
              <px-span-tooltip bottom
                               :text="resposta.fornecedor.pessoa.nome"
                               :tooltip="resposta.fornecedor.pessoa.nome"/>
              <px-show-quantidade-produtos-homologados small
                                                       :id-fornecedor="resposta.fornecedor.id"
                                                       :produtos="mappedProdutos(resposta)"/>
              <div class="caption mt-2">
                <px-span-tooltip bottom
                                 text-class="grey lighten-3 pr-3 pl-3 pt-1 pb-1 rounded-tag-small"
                                :text="`${resposta.cotacao.identificador} - ${resposta.cotacao.id}`"
                                 tooltip="Identificador e código da cotação"/>
              </div>
            </v-col>
            <v-col cols="12" sm="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on">{{ resposta.frete.tipoFrete }}&nbsp;
                    <div class="caption">
                      {{ resposta.frete.prazoEntrega
                        | pluralize(['dia útil', 'dias úteis']) }}
                    </div>
                  </div>
                </template>
                <span>Tipo de frete e prazo de entrega</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="2">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <px-forma-pagamento show-div
                                        :forma-pagamento="resposta.formaPagamento"
                                        :prazo-pagamento="resposta.prazoPagamento"/>
                  </span>
                </template>
                <span>{{ tooltipFormaPagamento(resposta) }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="3">
              <span>
                {{ totalConvertidoByResposta(resposta)
                  | currency('R$', casaDecimal(resposta.produtos)) }}
                <px-moeda-chip v-if="isMoedaEstrangeiraFn(moeda(resposta))"
                               :moeda="moeda(resposta)"/>
              </span>
              <div class="caption" v-if="isMoedaEstrangeiraFn(moeda(resposta))">
              {{ totalByResposta(resposta)
                | currency(
                    simboloMoedaFn(moeda(resposta)),
                    casaDecimal(resposta.produtos),
                    configuracaoFormatacaoMoedaFn(moeda(resposta))
                  ) }}
              </div>
              <div class="caption mt-2">
                {{ filteredProdutos(resposta.produtos).length }}
                / {{ resposta.produtos.length }} produto(s)
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <px-lista-produtos-resposta :produtos="filteredProdutos(resposta.produtos)"
                                      :loading-produto="computedLoadingProdutos"
                                      :id-fornecedor="resposta.fornecedor.id"
                                      :moeda="moeda(resposta)"
                                      @loading-produto="onLoadingProduto"
                                      @update-carrinho="emitUpdateCarrinho"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import { orderBy } from 'lodash';
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import { CasaDecimalUtils } from 'px-components';
import moedaMixin from '@/mixins/moeda-mixin';
import { totalProdutos } from './carrinho-matriz-calculo.service';
import ListaProdutosRespotas from './ListaProdutosRespostas.vue';

export default {
  mixins: [moedaMixin],
  props: {
    respostas: Array,
  },
  data() {
    return {
      loading: null,
      loadingProdutos: null,
      fornecedores: null,
    };
  },
  computed: {
    isRespondido() {
      return produto => produto.situacao
        === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
    filteredProdutos() {
      return (produtos) => {
        const filteredProdutos = produtos.filter(p => this.isRespondido(p.produto));
        return orderBy(filteredProdutos, ['produto.cotacaoProduto.id'], ['asc']);
      };
    },
    mappedProdutos() {
      return resposta => resposta.produtos.map(p => p.produto.cotacaoProduto);
    },
    casaDecimal() {
      return (produtos) => {
        const mappedProdutos = produtos.map(produto => produto.produto.cotacaoProduto.produto);
        return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
      };
    },
    moeda() {
      return resposta => resposta.moeda;
    },
    tooltipFormaPagamento() {
      return resposta => (resposta.prazoPagamento ? 'Forma e prazo de pagamento' : 'Forma de pagamento');
    },
    totalByResposta() {
      return (resposta) => {
        const precision = this.casaDecimal(resposta.produtos);
        return totalProdutos(resposta.produtos, precision).total;
      };
    },
    totalConvertidoByResposta() {
      return (resposta) => {
        const precision = this.casaDecimal(resposta.produtos);
        return totalProdutos(resposta.produtos, precision).totalConvertido;
      };
    },
    computedLoadingProdutos() {
      return this.loadingProdutos;
    },
    orderedRespostas() {
      return orderBy(this.respostas, 'fornecedor.pessoa.nome', 'asc');
    },
  },
  methods: {
    onLoadingProduto(loading) {
      this.loadingProdutos = loading;
    },
    emitUpdateCarrinho() {
      this.$emit('update-carrinho');
    },
  },
  components: {
    PxListaProdutosResposta: ListaProdutosRespotas,
  },
};

</script>
<style scoped>
.container {
  padding: 0.9rem;
}
</style>
